import React from 'react'
import HMapCollapsableContainer from '../../components/HMapCollapsableContainer'
import HMapDetailsContentTabs from '../detailsPanel/HMapDetailsContentTabs'

const HMapTabDataItem = ({
  dataItem,
  setCurrentPanel,
  allHeatMaps,
  setAllHeatMaps
}) => {
  const { id, name, pin, star, type } = dataItem

  return (
    <HMapCollapsableContainer
      id={id}
      name={name}
      pin={pin}
      star={star}
      type={type}
      setCurrentPanel={setCurrentPanel}
      allHeatMaps={allHeatMaps}
      setAllHeatMaps={setAllHeatMaps}
    >
      <HMapDetailsContentTabs
        id={id}
        readonly={true}
        allHeatMaps={allHeatMaps}
        setAllHeatMaps={setAllHeatMaps}
      />
    </HMapCollapsableContainer>
  )
}

export default React.memo(HMapTabDataItem)
